import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import { twMerge } from 'tailwind-merge'

import PictureViewer from '@/components/PictureViewer.vue'
import { useContext } from '@/composables/context'
import { authModule } from '@/store'
import { Trip } from '@/types/trip'
import { User } from '@/types/user'

export interface StackedAttendeesGroupProps {
  trip: Trip
  orientation?: 'horizontal' | 'vertical'
  size?: 'small' | 'large'
  twClass?: string | string[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'StackedAttendeesGroup',
  props: {
    trip: null,
    orientation: { default: 'horizontal' },
    size: { default: 'large' },
    twClass: { default: undefined }
  },
  setup(__props: any, { expose }) {

const props = __props as { trip: Trip, orientation: 'horizontal' | 'vertical', size: 'small' | 'large', twClass: string | string[] };



expose({ showAttendeePicture, formattedAttendeeName })

const { i18n } = useContext()

const availableAttendees = computed(
  () => props.trip?.attendees.slice(0, 3) ?? [],
)
const attendeePictureUrls = computed(() => {
  return availableAttendees.value.map((attende) => attende.picture)
})

const showLightBox = ref(false)
const imageIndex = ref(0)

function showAttendeePicture(attendee: User, index: number): void {
  if (attendee.picture) {
    imageIndex.value = index
    showLightBox.value = true
  }
}

function formattedAttendeeName(attendee: User) {
  if (attendee.id === authModule.user.id) {
    return i18n.t('i').toString()
  }

  return attendee.firstName
}

return { __sfc: true,props, i18n, availableAttendees, attendeePictureUrls, showLightBox, imageIndex, showAttendeePicture, formattedAttendeeName, twMerge, PictureViewer }
}

})